import { useEffect } from 'react'
import { KatalMetricsPublisher } from './metrics'

// hooks to emit render metrics to PMET once component mounted
export const useEmitInitialRender = (context: string): void => {
  useEffect(() => {
    const metricsPublisher = KatalMetricsPublisher.newChildActionPublisherForMethod(context)
    metricsPublisher.publishCounterMonitor('rendered', 1)
  }, [])
}
